export default {
  print: {
    print: 'Tisk',
    segment: 'Segment',
    preparingPrinting: 'Příprava tisku',
    readyToPrint: 'Připraveno k tisku'
  }
}
